/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowCapsule = createReactComponent("outline", "arrow-capsule", "IconArrowCapsule", [["path", { "d": "M18 15a6 6 0 1 1 -12 0v-6a6 6 0 1 1 12 0v2", "key": "svg-0" }], ["path", { "d": "M15 8l3 3l3 -3", "key": "svg-1" }]]);

export { IconArrowCapsule as default };
//# sourceMappingURL=IconArrowCapsule.mjs.map
